import React,{useState}from 'react'
import {useNavigate} from 'react-router-dom'
import { Footer } from './Footer1'
import Nav from './Nav';

const Checkout = () => {
     const navigate = useNavigate()
     const [form,setform]= useState({
          name : '',
          Email : '',
          Shippingaddress:'',
          touched : {
               name : false,
               Email: false ,
               Shippingaddress : false
          }

     })


     

     const error= {
          name : form.name.length===0,
          Email : form.Email.length===0,
          Shippingaddress: form.Shippingaddress.length===0

     }

     const disable = Object.keys(error).some((x)=>error[x])
     

     const handlechange = (ev)=>{
     
          const{name ,value}= ev.target
          setform((prevState)=>{
               return{
                    ...prevState,
                         [name]:value
                    
               }
          })
     }
     const handlesubmit=ev=>{
if(disable){
     ev.PreventDefault()

}else{
     navigate('/Order')
}
          
     }

     
    const handleblur = (ev)=>{
     const{name ,value}= ev.target
     setform((prevState)=>{
          return{
               ...prevState,
                   touched :{...form.touched,[name]:true}
               
          }
     })

    }
         

    const styleinput = (x)=>{
     
     const checkerror = error[x] ? form.touched[x] : false 
     if(checkerror){
          return{
               border : '2px solid red'
          }
          
     }
    }
     

  return (
     <>
     <Nav/>
     <form className='checkout' onSubmit={handlesubmit}>
      <h1> Shopping Checkout</h1>
      <h4> Your Details</h4>
      <hr/>
      <div className='detail-wrapper'>
      <div className='name-wrapper'>
<p> Name</p>
<input type='text' onBlur={handleblur} style={styleinput('name')} name='name' placeholder='Enter your name' onChange={handlechange}/>
     </div>

     <div className='Email-wrapper'>
<p> Email</p>
<input type='Email' name='Email' onBlur={handleblur} style={styleinput('Email')}  placeholder='Enter your Email' onChange={handlechange}/>
     </div>
      </div>
      <h4> Address Details</h4>
      <hr/>
      <div className='copyshipping-wrapper'>
<p>Copy to shipping</p> 
<input type='checkbox'/>
      </div>

      <div className='Address-wrapper'>
      <div className='Billing-wrapper'>
<p> Billing Address (optional)</p>
<div className='input-wrapper'>
<input type='text' />
<input type='text'/>
<input type='text'/>
</div>

     </div>

     <div className='Billing-wrapper'>
<p> shipping Address</p>
<div className='input-wrapper' >
<input type='text'  name='Shippingaddress' onBlur={handleblur} style={styleinput('Shippingaddress')} placeholder='Enter your shipping address' onChange={handlechange}/>
<input type='text'  placeholder='state'/>
<input type='text' placeholder='Country'/>
</div>

     </div>
      </div>
     
     <div className='checkout-btn-wrapper'>

      <button disabled={ disable} >Confirm Order</button>
     </div>
  
    </form>
    <Footer/> 
    </>
  )
}

export default Checkout